import {Injectable} from '@angular/core';
import {AdditionalPACData} from '../../models/additional-pac-data.model';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DeriveCourtService {
  constructor(private readonly http: HttpClient) {}

  fetchCourtName(additionalPACData: AdditionalPACData): Observable<any> {
    const token = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    return this.http.post('api/derive-court', additionalPACData, { headers });
  }
}
